import { createIcon } from './icon';

export const LanguageIcon = createIcon(
  <svg
    width="19"
    height="17"
    viewBox="0 0 19 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.08333 16.6667L12.875 6.66667H14.625L18.4167 16.6667H16.6667L15.7708 14.125H11.7292L10.8333 16.6667H9.08333ZM2.5 14.1667L1.33333 13L5.54167 8.79167C5.05556 8.30556 4.61458 7.75 4.21875 7.125C3.82292 6.5 3.45833 5.79167 3.125 5H4.875C5.15278 5.54167 5.43056 6.01389 5.70833 6.41667C5.98611 6.81944 6.31944 7.22222 6.70833 7.625C7.16667 7.16667 7.64236 6.52431 8.13542 5.69792C8.62847 4.87153 9 4.08333 9.25 3.33333H0V1.66667H5.83333V0H7.5V1.66667H13.3333V3.33333H10.9167C10.625 4.33333 10.1875 5.36111 9.60417 6.41667C9.02083 7.47222 8.44444 8.27778 7.875 8.83333L9.875 10.875L9.25 12.5833L6.70833 9.97917L2.5 14.1667ZM12.25 12.6667H15.25L13.75 8.41667L12.25 12.6667Z"
      fill="currentColor"
    />
  </svg>,
  'LanguageIcon'
);
